import { PaginationArgs, GqlPageInfos } from '@wm-front/shared/interfaces'
import { MatTablePaginationDirection } from '@wm-front/core'

/** Returns the pagination args used for any paginated grapqhQl query
 * @param { MatTablePaginationDirection } direction the direction of sorting
 * @param { number } nbrToShow the number of entity to display
 * @param { GqlPageInfos } pageInfos the gql page infos required by a gql query
 * @param { boolean } reset whether or not the pagination cursors should be reset
 */
export function getPaginationArgs(
  direction: MatTablePaginationDirection,
  nbrToShow: number,
  pageInfos: GqlPageInfos,
  reset?: boolean
): PaginationArgs | null {
  let pagination: PaginationArgs | null = null

  if (direction === MatTablePaginationDirection.NEXT) {
    pagination = { first: nbrToShow, after: reset ? '' : pageInfos.endCursor }
  } else if (direction === MatTablePaginationDirection.PREVIOUS) {
    pagination = {
      last: nbrToShow,
      before: reset ? '' : pageInfos.startCursor,
    }
  }

  return pagination
}
